import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=64383e17&scoped=true"
import script from "./DataList.vue?vue&type=script&setup=true&lang=js"
export * from "./DataList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DataList.vue?vue&type=style&index=0&id=64383e17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64383e17",
  null
  
)

export default component.exports